import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import icon2x from "leaflet/dist/images/marker-icon-2x.png";
import shadow from "leaflet/dist/images/marker-shadow.png";

const cityIcon = new L.Icon({ iconUrl: icon, iconRetinaUrl: icon2x, shadowUrl: shadow, iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41] });
const hqIcon = new L.Icon({ iconUrl: "https://maps.google.com/mapfiles/ms/icons/red-dot.png", iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -30] });

const HQ = { lat: 32.7357, lng: -97.1081, name: "Lazy Days Home Services" };

// Interactive coverage map (Leaflet + OpenStreetMap — no API key required).
// Plots the HQ + a pin for each served city, each linking to its geo page.
export function CoverageMap({ cities }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { attribution: '&copy; OpenStreetMap contributors', maxZoom: 18 })
      .on("tileload", e => { Object.assign(e.tile, { alt: "DFW service area map", title: "DFW service area map", width: 256, height: 256 }); })
      .addTo(map);
    const pts = [];
    L.marker([HQ.lat, HQ.lng], { icon: hqIcon }).addTo(map).bindPopup(`<b>${HQ.name}</b><br/>Our Arlington, TX home base<br/><a href="tel:8172777387">(817) 277-7387</a>`);
    pts.push([HQ.lat, HQ.lng]);
    (cities || []).forEach(c => {
      if (c.lat && c.lng) {
        L.marker([c.lat, c.lng], { icon: cityIcon }).addTo(map).bindPopup(`<b>${c.city}, ${c.state}</b><br/><a href="/service-areas/${c.slug}">House cleaning in ${c.city} &raquo;</a>`);
        pts.push([c.lat, c.lng]);
      }
    });
    if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 11 });
    ref.current.querySelectorAll("img.leaflet-marker-icon, img.leaflet-marker-shadow").forEach(img => { Object.assign(img, { alt: img.alt || "Service area map pin", title: "Service area map pin", width: img.offsetWidth || 25, height: img.offsetHeight || 41 }); });
    return () => { map.remove(); mapRef.current = null; };
  }, [cities]);
  return <div ref={ref} data-testid="coverage-map" style={{ width: "100%", height: 420, borderRadius: 8, overflow: "hidden", zIndex: 0, border: "1px solid #ddd" }} />;
}
